import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useTheme } from '../contexts/ThemeContext';
import Navbar from '../components/Navbar';

function SunIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
      <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd"/>
    </svg>
  );
}
function MoonIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
      <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"/>
    </svg>
  );
}

export default function About() {
  const { user } = useAuth();
  const { darkMode, toggleDarkMode } = useTheme();

  const content = (
    <div className="about-page">
      <div className="about-card">
        <h2 className="about-section-heading">What is RankedSAT?</h2>
        <div className="about-body">
          <p>RankedSAT is a 1v1 quiz-game where players compete to score the highest scores on SAT exams. The game was designed to make studying for the SAT less monotonous and help players identify subject areas of weakness and find motivation to consistently practice the test.</p>
        </div>

        <h2 className="about-section-heading" style={{ marginTop: 32 }}>About Us</h2>
        <div className="about-body">
          <p>We are top 20 university students who hated studying for the SAT.</p>
          <p>It took RankedSAT's founder six attempts to get a 1520 on the SAT, with their first score being a 1050. It took most of the other developers six or seven tries. Despite most of us being the top of our class, we all scored terribly on our first tests, and needed tens and hundreds of hours of studying to master the SAT and score in the 99th percentile.</p>
          <p>Although the SAT doubtlessly helped us get into our elite colleges, we unanimously agree that the test measures students' capacity to learn SAT-relevant concepts over real intellectual curiosity or critical thinking. Moreover, the existing resources for studying for the SAT are mostly just practice exams which are extraordinarily boring and difficult to stay motivated to work on.</p>
          <p className="about-sign-off">So, this game is our first attempt at designing a more enjoyable way to work with the SAT. We hope you enjoy it, and if you have user feedback for the game, bug reports, please email them to us.</p>
        </div>
      </div>
    </div>
  );

  if (user) {
    return (
      <div className="app-shell">
        <Navbar />
        {content}
      </div>
    );
  }

  return (
    <div className="lp-shell">
      <nav className="navbar lp-topnav">
        <Link to="/login" className="navbar-brand">
          <img src="/RANKEDSATLOGO.png" alt="RankedSAT" style={{ height: 'auto', width: 160, objectFit: 'contain', display: 'block' }} />
        </Link>
        <div style={{ display: 'flex', gap: 4 }}>
          <Link to="/login" className="navbar-link">Home</Link>
        </div>
        <div className="navbar-right">
          <button
            className="btn btn-ghost btn-sm navbar-theme-btn"
            onClick={toggleDarkMode}
            title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}
          >
            {darkMode ? <SunIcon /> : <MoonIcon />}
          </button>
          <Link to="/login" className="btn btn-primary btn-sm" style={{ fontWeight: 700 }}>
            Sign Up / Log In
          </Link>
        </div>
      </nav>
      {content}
    </div>
  );
}
